import React from 'react'
import Upload from '../../Upload'
import isEmpty from 'lodash/isEmpty'
import style from './style.module.less'
import Panel from '../Panel'
import { isExperienceStore } from '@util'
import { getMoney } from '@hlj/hlj-utils'

/**
 *  签单卡片
 */
const SignCard = ({ item, operator }) => {
  const { signing_card = {} } = item
  const isExperience = isExperienceStore()
  return (
    <Panel
      icon="//qnm.hunliji.com/o_1d8n8sluc1ko736ags1ee75e6t.png"
      item={item}
    >
      <div className={style.item}>
        <span>需求类型&nbsp;:&nbsp;</span>
        <span>{signing_card.property_name}</span>
      </div>
      {isExperience ? (
        <div className={style.item}>
          <span>商家名&nbsp;:&nbsp;</span>
          <span>{signing_card.order_merchant_name}</span>
        </div>
      ) : (
        <div className={style.item}>
          <span>商品名&nbsp;:&nbsp;</span>
          <span>{signing_card.set_meal_title}</span>
        </div>
      )}

      <div className={style.item}>
        <span>签单总金额&nbsp;:&nbsp;</span>
        <span>{getMoney(signing_card.total_money)}</span>
      </div>

      {isExperience && (
        <div className={style.item}>
          <span>佣金&nbsp;:&nbsp;</span>
          <span>{getMoney(signing_card.brokerage)}</span>
        </div>
      )}

      <div className={style.item}>
        <span>备注&nbsp;:&nbsp;</span>
        <span>{signing_card.remark}</span>
      </div>
      {!isEmpty(signing_card.attachments) && (
        <div className={style.item}>
          <span>附件&nbsp;:&nbsp;</span>
          <Upload showUpload={false} value={signing_card.attachments} />
        </div>
      )}

      <div className={style.item}>
        <span>操作人&nbsp;:&nbsp;</span>
        <span>{operator}</span>
      </div>
    </Panel>
  )
}

export default SignCard
